import React from 'react';
import {useForm} from 'react-hook-form';
import SubmitButton from './fields/SubmitButton';
import { useAppConfiguration } from '../../AppConfiguration';

const FilterSidebar = ({forListing, filters, hiddenFilters = [], onSubmit, formDescription = null}) => {
    const {[forListing + 'FilterConfiguration']: filterConfiguration} = useAppConfiguration();
    const {register, control, handleSubmit} = useForm();

    // Only use not disabled filters
    const selectedFilters = [];
    for (const filterKey of Object.keys(filters)) {//
        if (filterConfiguration[filterKey] !== false) {
            selectedFilters.push(React.cloneElement(filters[filterKey], {
                key: filterKey,
                forListing,
                register,
                control,
            }));
        }
    }

    return (
        <div className="listings-sidebar">
            <div className="search-area default-ad-search">
                {formDescription &&
                    <p id="sidebar-filter-description" className="sr-only">
                        {formDescription}
                    </p>
                }
                <form onSubmit={handleSubmit(onSubmit)} aria-labelledby={formDescription ? 'filter-sidebar-description' : undefined}>
                    {Object.keys(hiddenFilters).map(filterKey => (
                        <input
                            key={filterKey}
                            type="hidden"
                            name={filterKey}
                            ref={register}
                            defaultValue={hiddenFilters[filterKey]}
                        />
                    ))}

                    {selectedFilters}

                    <SubmitButton
                        className="btn btn-gradient btn-gradient-two btn-block btn-icon icon-right m-top-40"
                    />
                </form>
            </div>
        </div>
    );
};

export default FilterSidebar;
